import { useApiAction } from '../_shared/use-api-action';
import { registrationApi } from './api';

export function useCheckEmail() {
  return useApiAction(registrationApi.checkEmail);
}

export function useRequestCode() {
  return useApiAction(registrationApi.requestCode);
}

export function useVerifyCode() {
  return useApiAction(registrationApi.verifyCode);
}

export function useCompleteSignup() {
  return useApiAction(registrationApi.completeSignup);
}

export function useRequestLoginCode() {
  return useApiAction(registrationApi.requestLoginCode);
}

export function useLoginWithCode() {
  return useApiAction(registrationApi.loginWithCode);
}

export function useLoginWithLink() {
  return useApiAction(registrationApi.loginWithLink);
}
